import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'
import { getTimezoneDate } from 'utils/date'

import DatePicker from 'material-ui/DatePicker'
import TextField from 'material-ui/TextField'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import InputMoney from 'components/InputMoney'
import {getMonth} from 'utils/date'


let select = dirtyRead(
	(state, props) => ({
		term: doc(state, props.objectID)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: "hidden"
				   , overflowX: "hidden"
					 , paddingBottom:"10px"
					 , paddingRight:"5px"
				}}
			>
				<div style={{width: "100%", padding:"10px 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<div style={{clear: "both"}}>
						<div style={{margin: "0px", display:"inline-block", width: "40px"}}>
							<img
								src="/static/img/calendar-green.png"
								style={{
								  width: "20px"
								, position: "relative"
								, top: "3px"
								}}
							/>
						</div>
						<div style={{margin: "0px", display:"inline-block", width: "80%"}}>
							<p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
							Sign date</p>
							<DatePicker
								style={{
									color: "#000"
								}}
								textFieldStyle={{
									fontSize: "16px"
									, width: "100px"
									, height: "36px"
									, color: "#000"
								}}
								underlineStyle={{
									borderBottom: props.term.date ? "0px solid" : "0px solid"
								}}
								inputStyle={{color: "#000"}}
								disabled={true}
								underlineDisabledStyle={{borderBottom: "0px solid"}}
								hintText="Select"
								formatDate= {(date)=>{
									//debugger
									if (!date || date.toString()=="Invalid Date") return ""
									return getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
								}
								hintStyle={{top: "8px"}}
								style={{width: "100px", height: "35px", marginTop: "8px"}}
								value={(props.term.date)?getTimezoneDate(props.term.date):""}
								onChange={(evt, value)=>
									props.STAGE({
										_id: props.objectID
										, date: "" + value.getFullYear()+'-'+(value.getMonth()+1<10 ? "0" : "")+(value.getMonth()+1)+'-'+(value.getDate()<10 ? "0" : "")+value.getDate()
									})
								}
							/>
						</div>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "40px"}}>
						<img
							src="/static/img/calendar-green.png"
							style={{
							  width: "20px"
							, position: "relative"
							, top: "3px"
							}}
						/>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "40%"}}>
						<p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
						Move-in date</p>
						<DatePicker
							style={{
								color: "#000"
							}}
							textFieldStyle={{
								fontSize: "16px"
								, width: "100px"
								, height: "36px"
								, color: "#000"
							}}
							disabled={true}
							underlineStyle={{
								borderBottom: props.term.dateFrom ? "0px solid" : "0px solid"
							}}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							hintText="Select"
							formatDate= {(date)=>{
								//debugger
								if (!date || date.toString()=="Invalid Date") return ""
								return getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
							}
							hintStyle={{top: "8px"}}
							style={{width: "100px", height: "35px", marginTop: "8px"}}
							value={(props.term.dateFrom)?getTimezoneDate(props.term.dateFrom):""}
							onChange={(evt, value)=>
								props.STAGE({
									_id: props.objectID
									, dateFrom: "" + value.getFullYear()+'-'+(value.getMonth()+1<10 ? "0" : "")+(value.getMonth()+1)+'-'+(value.getDate()<10 ? "0" : "")+value.getDate()
								})
							}
						/>
					</div>
					<div style={{margin: "0px", display:"inline-block", width: "40%"}}>
						<p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
						Move-out date</p>
						<DatePicker
							style={{
								color: "#000"
							}}
							disabled={true}
							textFieldStyle={{
								fontSize: "16px"
								, width: "100px"
								, height: "36px"
								, color: "#000"
							}}
							underlineStyle={{
								borderBottom: props.term.dateTill ? "0px solid" : "0px solid"
							}}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							hintText="Select"
							formatDate= {(date)=>{
								//debugger
								if (!date || date.toString()=="Invalid Date") return ""
								return getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()
							}}
							hintStyle={{top: "8px"}}
							style={{width: "100px", height: "35px", marginTop: "8px"}}
							value={(props.term.dateTill)?getTimezoneDate(props.term.dateTill):""}
							onChange={(evt, value)=>
								props.STAGE({
									_id: props.objectID
									, dateTill: "" + value.getFullYear()+'-'+(value.getMonth()+1<10 ? "0" : "")+(value.getMonth()+1)+'-'+(value.getDate()<10 ? "0" : "")+value.getDate()
								})
							}
						/>
					</div>
					<div style={{width:"100%", paddingLeft:"40px"}}>
						<TextField
							floatingLabelText="Rent"
							defaultValue={props.term.rent}
							style={{
								width: "100%",
								marginTop: "-10px",
								color: "#000"
							}}
							disabled={true}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.term.rent}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
								  , rent: evt.target.value
								})
							}
						/>
					</div>
					<div style={{width:"100%", paddingLeft:"40px"}}>
						<TextField
							floatingLabelText="Security deposit"
							defaultValue={props.term && props.term.securityDeposit}
							disabled={true}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							style={{
								width: "100%",
								marginTop: "-10px",
								color: "#000"
							}}
							inputStyle={{color: "#000"}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.term && props.term.securityDeposit}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
								  , securityDeposit: evt.target.value
								})
							}
						/>
					</div>
					<div style={{width:"100%", paddingLeft:"40px"}}>
						<TextField
							floatingLabelText="Pet Deposit"
							defaultValue={props.term && props.term.petDeposit}
							style={{
								width: "100%",
								marginTop: "-10px",
								color: "#000"
							}}
							disabled={true}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.term && props.term.petDeposit}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
								  , petDeposit: evt.target.value
								})
							}
						/>
					</div>
					<div style={{width:"100%", paddingLeft:"40px"}}>
						<TextField
							floatingLabelText="Late fee"
							defaultValue={props.term && props.term.lateFee}
							style={{
								width: "100%",
								marginTop: "-10px",
								color: "#000"
							}}
							disabled={true}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.term && props.term.lateFee}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
								  , lateFee: evt.target.value
								})
							}
						/>
					</div>
					<div style={{width:"100%", paddingLeft:"40px"}}>
						<TextField
							floatingLabelText="Notification Period (days)"
							defaultValue={props.term && props.term.notificationPeriod || 60}
							style={{
								width: "100%",
								marginTop: "-10px",
								color: "#000"
							}}
							disabled={true}
							inputStyle={{color: "#000"}}
							underlineDisabledStyle={{borderBottom: "0px solid"}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.term && props.term.notificationPeriod || 60}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
								  , notificationPeriod: evt.target.value
								})
							}
						/>
					</div>
				</div>
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/termForm/LeftSide.js